module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bee-plugin-container",
    attrs: {
      "id": "bee-plugin-container"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-344e56b2!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/partials/Bee.vue
// module id = 723
// module chunks = 1